<div data-cy="snackbar" class="cm-snackbar__container {{ 'cm-snackbar-' + data.type }}">
  <div class="cm-snackbar__icon">
    <mat-icon> {{ snackbarIcon }} </mat-icon>
  </div>
  <div data-cy="toast-message-content" class="cm-snackbar__content">
    <span
      data-cy="snackbar-content-title"
      class="cm-snackbar__content--title typography__alert-title"
      *ngIf="data.title"
    >
      {{ data.title | translate }}
    </span>
    <span
      data-cy="snackbar-content-description"
      class="cm-snackbar__content--description typography__body-1"
      *ngIf="data.description"
    >
      {{ data.description | translate }}
    </span>
  </div>
  <div class="cm-snackbar__action d-flex align-items-center" *ngIf="data.action" data-cy="snackbar-action">
    <container-element [ngSwitch]="data?.actionButtonMode">
      <ng-container *ngSwitchCase="BasicButtonModes.FLAT">
        <div
          class="typography__button-large cm-snackbar__action-button"
          [ngClass]="{
            'cm-snackbar__action-button--info': data.type === SnackBarsTypes.INFO
          }"
          (click)="action()"
        >
          {{ data.action | translate }}
        </div>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <cm-basic-button
          class="typography__button-large cm-snackbar__action-button cm-snackbar__action-button--error"
          (click)="action()"
        >
          {{ data.action | translate }}
        </cm-basic-button>
      </ng-container>
    </container-element>
  </div>
  <div class="cm-snackbar__close">
    <cm-icon-button
      data-cy="snackbar-close"
      icon="close"
      [color]="BasicButtonColors.WHITE"
      (clickEvent)="close()"
    ></cm-icon-button>
  </div>
</div>
